
import React from 'react';
import ScintillaOfArt2023 from 'views/ScintillaOfArt2023'

const SecondarySchoolpage = () => {
  return <ScintillaOfArt2023/>;
};

export default SecondarySchoolpage;